export const getAmount = (
  x: number | string,
  y: number | string,
): number | string => {
  if (!isFinite(+x) || !isFinite(+y)) return 0;
  return (+Number(x).toFixed(2) * +Number(y).toFixed(2)).toFixed(2);
};
